module.exports = __webpack_public_path__ + "static/media/cm.5f219fa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cm.svg
// module id = 88
// module chunks = 0